import React, { useState, useEffect } from "react";
import "../../components/AddStatus/AddStatus.css";
import axios from "axios";

const AddStatus = ({tokenStorage,openAddProfile,setOpenAddProfile}) => {
  const baseAPI = process.env.REACT_APP_API_URL;
  const [formData, setFormData] = useState({
    StatusID: 0,
    StatusName: "",
  
    createdBy: "Vishal",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    try {
      const storedToken = JSON.parse(localStorage.getItem("token"));
      // Make a POST request to your API endpoint
      const response = await axios.post(
        `${baseAPI}adminpost/AddStatus`,
        formData, // Send formData as the request body
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
          },
        }
      );
  
  
      // Optionally, reset the form
      setFormData({
        StatusID: 0,
        StatusName: "",
      
        createdBy: "Vishal",
      });
      tokenStorage();
      setOpenAddProfile (!openAddProfile); 
    } catch (error) {
      // Handle errors (e.g., show an error message)
      console.error("Error posting data:", error);
    }
  };

  return (
    <div className="container-fluid">
      <br />

      <div className="statusDetail">
        <div className="status-form" >
          <table style={{ width: "100%" }}>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
            <tr className="tableHeading">
              <td>Status Name*</td>
            </tr>

            <tr>
              
              <td>
              <input
                  type="text"
                  name="StatusName"
                  value={formData.StatusName}
                  placeholder="Please Enter*"
                  onChange={handleChange}
                />
              </td>
            
            </tr>
            <tr className="space">
              <td colSpan={3}></td>
            </tr>
          </table>
          <br />
          <hr />
          <div className="reset-addStatus-button">
          <button  type="submit" onClick={handleSubmit}  style={{marginRight: "10px", backgroundColor: "#5B489D", color: "white"}}>
              Add Status
            </button>
            <button style={{ backgroundColor: "#F15843", color: "white" }}>
              Reset
            </button>
            
          </div>
        </div>
      </div>
      <br />
    </div>
  );
};

export default AddStatus;
